import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import Header from '@/components/Header';

/**
 * Layout for all protected /app/* routes.
 * Wraps all child routes with authentication protection.
 */
export default function AppLayout() {
  return (
    <ProtectedRoute>
      <Header />
      <Outlet />
    </ProtectedRoute>
  );
}
